export default __webpack_public_path__ + "static/media/no-connection.57e9549b.svg";